export default {
    Metadata: {
        Name: "Remove",
        Description: "Returns a base string with a specified string removed.",
        Syntax: "Remove(string, startPos_number, length_number)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(fullString, startPos, length) {
        if (fullString == null || startPos == null || length == null) {
            return null;
        }

        if (typeof fullString != 'string') {
            fullString = fullString.toString();
        }

        return fullString.substring(0, startPos) + fullString.substring(startPos + length, fullString.length);
    },
};

